import React from 'react'
import { Link } from 'react-router-dom'
import CountryAdminAdding from './countryAdminAdd'

class CountryAdminAddingTab extends React.Component {
  state = {}
  componentDidMount() {
    if (
      this.props.match.params.country_id !== undefined &&
      this.props.match.params.country_id !== null &&
      this.props.match.params.country_id !== 0 &&
      this.props.match.params.country_id !== ''
    ) {
      this.setState({ country_id: this.props.match.params.country_id })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.country_id ? 'Edit' : 'Add'} Country Admin</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/country-admin">Country Admin List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.country_id ? 'Edit' : 'Add'} Country Admin
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'add_dealer_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.country_id !== undefined &&
                        this.state.country_id !== null &&
                        this.state.country_id !== 0 &&
                        this.state.country_id !== '' ? (
                          <CountryAdminAdding
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            country_id={this.state.country_id}
                          />
                        ) : (
                          <CountryAdminAdding
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CountryAdminAddingTab
